import { diff } from 'deep-object-diff'
import { clone, deleteDeep, mergeDeep } from '@/helpers'

type FormType = Record<any, any> // поля сущности, редактируемые через форму (обычно меньше всего полей)
type ListItemType = Record<any, any> // сущность в составе списка
type SingleType = Record<any, any> // сущность, обычно запрашиваемая по id (наибольшее количество полей)

type Type = FormType | ListItemType | SingleType

export default class Model {
  static model: FormType = {}

  static get() {
    return clone(this.model) as FormType
  }

  static prepare(model: Type, without: (keyof Type)[]) {
    const newModel = clone(model)

    without.forEach((key) => {
      if (Object.hasOwn(newModel, key)) delete newModel[key]
    })

    return newModel as Partial<Type>
  }

  static prepareWith(
    model: Type,
    keys: (keyof Type)[] = Object.keys(this.model)
  ) {
    const newModel = clone(model)

    keys.forEach((key) => {
      if (!Object.hasOwn(newModel, key)) delete newModel[key]
    })

    return newModel as Partial<Type>
  }

  static difference(snapshot: Type, formModel: FormType) {
    return diff(snapshot as Record<string, any>, formModel) as Partial<Type>
  }

  static reset(formModel: Type, snapshot: Type = this.model) {
    return Object.assign(formModel, clone(snapshot)) as Type
  }

  static mergeTogether(model: Type) {
    return mergeDeep(this.get(), clone(model)) as Type
  }

  static mergeTogetherAndCutExcess(model: Type, deep?: boolean) {
    const merged = this.mergeTogether(model)

    deleteDeep(merged, this.model, deep)

    return merged as FormType
  }

  static onlyModelKeysDiff(snapshot: Type, formModel: Type, deep?: boolean) {
    const preparedSnapshot = this.mergeTogetherAndCutExcess(snapshot, deep)
    const preparedFormModel = this.mergeTogetherAndCutExcess(formModel, deep)

    return this.difference(
      preparedSnapshot,
      preparedFormModel
    ) as Partial<FormType>
  }

  static pickOnlyAndMergeTogether(model: Type, keys: (keyof Type)[]) {
    const cloned = clone(model)

    const picked = Object.keys(cloned).reduce((acc, key) => {
      if (keys.includes(key)) acc[key] = cloned[key]

      return acc
    }, {} as Partial<Type>)

    return this.mergeTogether(picked)
  }
}
